import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.string.replace-all.js";
export var Sanitize = /*#__PURE__*/function () {
  function Sanitize() {
    _classCallCheck(this, Sanitize);
  }
  return _createClass(Sanitize, [{
    key: "escapeHTML",
    value: function escapeHTML(unsafe_str) {
      return unsafe_str.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll('\'', '&#39;').replaceAll('/', '&#x2F;').trim();
    }
  }]);
}();